import React, { Component } from "react";


export default class Flags extends Component {
  render() {
    const { deal, prefix } = this.props
    return (
      <div className='flags-container'>

        {deal.flags.includes('seminar_attendee_confirmed')  && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Confirmed Attendee</span>}
        {deal.flags.includes('seminar_attendee_not_confirmed')  && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Couldnt Confirm Attendee</span>}
        {deal.flags.includes('seminar_attended')  && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Attended Seminar</span>}
        {deal.flags.includes('seminar_not_attended')  && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Didn't Attended Seminar</span>}
        {deal.flags.includes('seminar_cancelled') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Cancelled</span>}
        {deal.flags.includes('seminar_rescheduled') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Rescheduled</span>}

        {!prefix && deal.flags.includes('completed') && <span className='toggle-flag toggle-flag-success'>Deal Complete</span>}
      </div>
    )
  }
}